import { Component, OnInit, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { DialogResultTypes, HowdenAlertService, IDialogResult, UIBlockerService } from '@howdeniberia/core-front';
import { tap } from 'rxjs';
import { IRiskService } from 'src/app/core/services/api/risk';
import { EditRiskMapper } from '../../mappers';
import { EditRiskViewModel } from '../../models';

@Component({
  selector: 'howden-edit-risk',
  templateUrl: './edit-risk.component.html',
  styleUrls: ['./edit-risk.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInput,
    MatLabel,
    MatButton,
    MatFormField,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose
  ]
})
export class EditRiskComponent implements OnInit {
  inputData = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<EditRiskComponent>>(MatDialogRef);
  private uiBlockerSrv = inject(UIBlockerService);
  private riskSrv = inject(IRiskService);
  private alertSrv = inject(HowdenAlertService);

  model = new EditRiskViewModel();

  ngOnInit(): void {
    if (this.riskId !== 'undefined' && this.riskId !== null) {
      this.uiBlockerSrv.block();
      this.riskSrv.get(this.riskId).subscribe((data) => {
        EditRiskMapper.mapForEdit(data, this.model);
        this.uiBlockerSrv.unblock();
      });
    }
  }

  saveRisk() {
    this.uiBlockerSrv.block();
    const request = EditRiskMapper.mapForUpdate(this.model);

    this.riskSrv
      .save(request)
      .pipe(
        tap((response) => {
          const msgResult = response.result as string;
          if (msgResult) {
            const title: string = $localize`: @@app.risk.save.result.warning.title:Advertencia!`;
            const message: string = $localize`: @@app.risk.save.result.warning.message:Riesgo no modificado:`;
            this.alertSrv.warning(title, `${message} ${msgResult}`);
          } else {
            const title: string = $localize`: @@app.risk.save.result.ok.title:Éxito!`;
            const message: string = $localize`: @@app.risk.save.result.ok.message:Riesgo guardado correctamente`;
            this.alertSrv.success(title, message);
          }
          this.uiBlockerSrv.unblock();
          this.dialogRef.close({ result: DialogResultTypes.OK } as IDialogResult<void>);
        })
      )
      .subscribe();
  }

  private get riskId(): string | null {
    return this.inputData.id as string | null;
  }
}
